import {
  ASSOCIATE_DOCUMENT_ORIGIN,
  ASSOCIATE_DOCUMENT_STATUS,
  ASSOCIATE_DOCUMENT_SYNC_STATUS,
  DOCUMENT_TYPE
} from './constants'

export default {
  getAssociateDocumentStatus() {
    return status => {
      return (
        ASSOCIATE_DOCUMENT_STATUS[status] ?? {
          title: status,
          color: ASSOCIATE_DOCUMENT_STATUS.accepted.color
        }
      )
    }
  },
  getAssociateDocumentSyncStatus() {
    return status => {
      return (
        ASSOCIATE_DOCUMENT_SYNC_STATUS[status] ?? {
          title: ASSOCIATE_DOCUMENT_SYNC_STATUS.initial.title,
          color: ASSOCIATE_DOCUMENT_SYNC_STATUS.initial.color
        }
      )
    }
  },
  getAssociateDocumentOrigin() {
    return status => {
      return (
        ASSOCIATE_DOCUMENT_ORIGIN[status] ?? {
          title: status,
          color: 'cyan'
        }
      )
    }
  },
  getDocumentType() {
    return type => {
      return (
        DOCUMENT_TYPE[type] ?? {
          title: type,
          color: DOCUMENT_TYPE.text.color,
          icon: DOCUMENT_TYPE.text.icon
        }
      )
    }
  }
}
